/** Available sorting options */
export enum SortingOption {
  BY_DATE_ASC = 'BY_DATE_ASC',
  BY_DATE_DESC = 'BY_DATE_DESC',
  BY_NAME_ASC = 'BY_NAME_ASC',
  BY_NAME_DESC = 'BY_NAME_DESC',
  BY_STATE = 'BY_STATE',
}
